import BaseTextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  root: {
    display: 'flex',
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  input: {
    fontSize: 16,
  },
  helper: {
    fontSize: 12,
  },
});

const TextFieldComponent = ({ classes, ...props }) => (
  <BaseTextField
    InputLabelProps={{ className: classes.input }}
    InputProps={{ className: classes.input }}
    FormHelperTextProps={{ className: classes.helper }}
    className={classes.root}
    fullWidth
    {...props}
  />
);
TextFieldComponent.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

export const TextField = withStyles(styles)(TextFieldComponent);
